import { useState } from 'react';
import BaseModal from '@c/modals/BaseModal';
import type { UserBike } from 'models/shared';
import SearchByVehicleForm from './SearchByVehicleForm';
import { useAuth } from 'context/AuthContext';

type DesktopSearchByVehicleProps = {
  isOpen: boolean;
  dismiss: () => void;
  onBikeComplete: (bike: UserBike, fromGarage?: boolean) => void;
  onClear?: () => void;
  variant?: 'add-to-garage' | 'filter';
  initialBike?: Partial<UserBike> | null;
};

export default function DesktopSearchByVehicle({
  isOpen,
  dismiss,
  onBikeComplete,
  onClear,
  variant = 'filter',
  initialBike,
}: DesktopSearchByVehicleProps) {
  const { userDoc } = useAuth();
  const [searchQuery, setSearchQuery] = useState('');
  const [prevIsOpen, setPrevIsOpen] = useState(isOpen);

  const hasSelectedBike = Boolean(
    initialBike?.year && initialBike?.make && initialBike?.model
  );
  const showClear = variant === 'filter' && !!onClear && hasSelectedBike;

  if (isOpen !== prevIsOpen) {
    setPrevIsOpen(isOpen);
    if (isOpen) {
      if (
        initialBike?.year &&
        initialBike?.make &&
        initialBike?.model &&
        !userDoc?.bikes?.length
      ) {
        setSearchQuery(
          `${initialBike.year} ${initialBike.make} ${initialBike.model}`
        );
      } else if (!initialBike) {
        setSearchQuery('');
      }
    }
  }

  return (
    <BaseModal
      isOpen={isOpen}
      dismiss={dismiss}
      title={
        variant === 'add-to-garage'
          ? 'Add Vehicle to Your Garage'
          : userDoc
          ? 'Find parts that fit'
          : 'Find Your Vehicle'
      }
      headerExtraButton={
        showClear ? (
          <button
            type="button"
            className="text-[1.8rem] font-semibold text-brand-secondary transition-colors hover:text-brand-secondary-darker"
            onClick={() => {
              onClear?.();
              dismiss();
            }}
          >
            Clear
          </button>
        ) : undefined
      }
    >
      <div className="h-[70rem] w-[50rem] overflow-y-auto p-8 sm:w-[65rem]">
        <SearchByVehicleForm
          onBikeComplete={onBikeComplete}
          onDismiss={dismiss}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
        />
      </div>
    </BaseModal>
  );
}
